import { PageHeaderMini } from 'components/eventView/layout/PageHeaderMini';
import { EventViewInformationPageContent } from 'components/eventView/pages/EVInformationPageContent';
import { StickyHeaderContentLayout } from 'elements/eventView/layout/StickyHeaderContentLayout';
import { StickyHeaderLayout } from 'elements/eventView/layout/StickyHeaderLayout';
import { motion } from 'framer-motion';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVInformationPageMobile = (props: Props) => {
    return (
        <S_EVInformationPageMobile className={props.className}>
            <StickyHeaderLayout>
                <PageHeaderMini>{Localization.INFO}</PageHeaderMini>
            </StickyHeaderLayout>
            <StickyHeaderContentLayout headerHeight={64}>
                <S_EventViewInformationPageContent />
            </StickyHeaderContentLayout>
        </S_EVInformationPageMobile>
    );
};

const S_EVInformationPageMobile = styled(motion.div)`
    background-color: #ecf0f5;
    height: 100%;
`;

const S_EventViewInformationPageContent = styled(EventViewInformationPageContent)`
    padding: 15px 10px 200px 10px;
`;
